import { createAction } from 'redux-actions';

interface updateTranstalionAction extends types.redux.translations.updateTranstalionAction {}

export const updateTranstalion: any = createAction(
	'UPDATE_TRANSLATION',
	(updatedTranslations: updateTranstalionAction) => updatedTranslations
);
